import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {Debounce} from '@core/tools/decorators';
import {ElPosition} from '@core/models/common';

@Directive({
    selector: '[position]'
})
export class PositionDirective implements OnInit {

    @Input() position: DOMRect;
    @Input() place: ElPosition = 'left';

    constructor(private el: ElementRef, private renderer: Renderer2) {
    }

    @Debounce(1)
    ngOnInit(): void {
        this.renderer.setStyle(this.el.nativeElement, 'top', this.place === 'bottom' ? this.position.y + this.position.height + 'px' : this.position.y + 'px');
        this.renderer.setStyle(this.el.nativeElement, 'left', this.place === 'right' ? this.position.x + this.position.width + 'px' : this.position.x + 'px');
        const menuHeight = this.el.nativeElement.offsetHeight;
        const heightMoreWindowBottom = menuHeight + this.position.y > window.innerHeight;
        const heightMoreWindowTop = menuHeight - this.position.y + this.position.height / 2 > 48; // header height;
        const widthMoreWindowRight = this.position.x + 250 > window.innerWidth;
        if (heightMoreWindowBottom) {
            this.place = 'top';
        }
        if (heightMoreWindowBottom && widthMoreWindowRight && !heightMoreWindowTop || this.place === 'top-left') {
            this.place = 'top-left';
            this.renderer.setStyle(this.el.nativeElement, 'transform', 'translate(-100%, calc(-100% + ' + this.position.height + 'px))');
        }
        if (heightMoreWindowTop && heightMoreWindowBottom) {
            this.place = 'left-center';
        }
        const className = this.place === 'top' ? 'content-top'
            : this.place === 'top-left' ? 'content-top-left'
                : this.place === 'bottom' ? 'content-bottom'
                    : this.place === 'bottom-left' ? 'content-bottom-left'
                        : this.place === 'left' ? 'content-left'
                            : this.place === 'left-center' ? 'content-left-center'
                                : this.place === 'right' ? 'content-right' : '';
        this.renderer.addClass(this.el.nativeElement, className);
        this.renderer.setStyle(this.el.nativeElement, 'z-index', '10010');
    }
}
